interface IAndroidWindow {
	TokenProvider: {
		logout(): void;
	};
}

const win = (window as any) as IAndroidWindow;

export function nativeLogoutAndoid() {
	win.TokenProvider.logout();
}
